import http from "./httpService";
import configData from ".././config.json";

var apiUrl = configData.apiUrl;
var receiptapiUrl = configData.receiptapiUrl;
var mailapiUrl = configData.mailapiUrl;
var qrCode = configData.qrCode;

export const getBoatBookedTicket = (data) => {
    const apiEndPoint = `${apiUrl}/BoatBookedTicket`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const getBoatOtherTicket = (data) => {
    const apiEndPoint = `${apiUrl}/BoatOtherTicket`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const getbookReceiptData = (data) => {
    const apiEndPoint = `${apiUrl}/CommonAPIMethod`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const getprintInstructionData = (data) => {
    const apiEndPoint = `${apiUrl}/PrintInstrucSvc`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const getOnlyOtherService = (data) => {
    const apiEndPoint = `${apiUrl}/OtherTicket`;
    return http.post(`${apiEndPoint}`,data);
  };

  export const getReceiptMail = (data) => {
    const apiEndPoint = `${mailapiUrl}/sendBoatingReceipt`;
    return http.post(`${apiEndPoint}`,data);
  };


  export const getQrBoat = (data) => {
    const apiEndPoint = `${qrCode}/BillQR`;
    return http.post(`${apiEndPoint}`,data);
  };


  export const getDownloadReceipt = (data) => {
    const apiEndPoint = `${receiptapiUrl}/ReceiptDownload?BookingId=${data.BookingId}&BoatHouseId=${data.BoatHouseId}&BookingType=${data.BookingType}`;
    
      fetch(apiEndPoint)
          .then(response => {
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.blob();
          })
          .then(blob => {
              const blobUrl = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.setAttribute('download', 'Receipt.pdf'); 
              link.style.display = 'none'; 
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(blobUrl);
              link.remove();
          })
          .catch(error => console.error('Error downloading file:', error));
  
  
    return http.get(`${apiEndPoint}`);
  };